<template src="./multi-items.html"></template>

<script lang="ts">
import { defineAsyncComponent } from 'vue'
import Modal from 'objects/modal/Modal.vue'
import ProductImage from 'objects/product-image/ProductImage.vue'


export default {
  data() {
    return { showMultiItemSearch: false }
  },
  props: {
    multiItems: { type: Array },
    promptText: { type: String },
    sku: { type: String }
  },
  emits: ['addItems', 'removeItem'],
  components: {
    'tt-multi-item-search':  defineAsyncComponent(
      // eslint-disable-next-line max-len
      () => import(/* webpackChunkName: 'multi-item-search' */ 'components/question/MultiItemSearch.vue')
    ),
    'tt-modal': Modal,
    'tt-product-image': ProductImage
  },
  computed: {
    searchExcludedCatItemIds() {
      return this.multiItems.map(item => item.id)
    }
  },
  methods: {
    addItemsAndClose(items) {
      this.$emit('addItems', items)
      this.closeSearch()
    },
    openSearch() {
      this.showMultiItemSearch = true
    },
    closeSearch() {
      this.showMultiItemSearch = false
      this.$refs.openSearchBtn.$el.focus()
    },
    removeItem(item) {
      this.$emit('removeItem', item)
    }
  }
}
</script>

<style lang="scss" src="./multi-items.scss"></style>
